import type { GridTile } from './types'

export enum CityZone {
  None = 0,
  Housing = 1,
}
export const ZONE_TO_LABEL: Record<CityZone, string> = {
  [CityZone.None]: 'Unzoned',
  [CityZone.Housing]: 'Housing',
} as const

export enum CityStructure {
  None = 0,
  House = 1,
  Road = 2,
}
export const STRUCTURE_TO_LABEL: Record<CityStructure, string> = {
  [CityStructure.None]: 'Inhabited',
  [CityStructure.House]: 'House',
  [CityStructure.Road]: 'Road',
} as const

export const EMPTY_GRID_TILE: GridTile = {
  0: {
    structure: CityStructure.None,
    zone: CityZone.None,
  },
} as const
export const GRID_COLUMNS_LENGTH = 64 as const
export const GRID_LINES_LENGTH = 64 as const
